export default __webpack_public_path__ + "static/media/chris.76bcc16b.png";